import React, { PureComponent } from 'react';
import { LineChart, Line, ReferenceLine,  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
//https://recharts.org/en-US/examples/TwoLevelPieChart
const data = [
  {
    name: 'Page A',
    chamados: 4000,
    retornos: 2400,
    amt: 2400,
  },
  {
    name: 'Page B',
    chamados: 3000,
    retornos: 1398,
    amt: 2210,
  },
  {
    name: 'Page C',
    chamados: 2000,
    retornos: 9800,
    amt: 2290,
  },
  {
    name: 'Page D',
    chamados: 2780,
    retornos: 3908,
    amt: 2000,
  },
  {
    name: 'Page E',
    chamados: 1890,
    retornos: 4800,
    amt: 2181,
  },
  {
    name: 'Page F',
    chamados: 2390,
    retornos: 3800,
    amt: 2500,
  },
  {
    name: 'Page G',
    chamados: 3490,
    retornos: 4300,
    amt: 2100,
  },
];

export default class Example extends PureComponent {
  static demoUrl = 'https://codesandbox.io/s/simple-line-chart-kec3v';
  constructor(props){
    super(props)
  }

  render() {
    return (
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          width={'100%'}
          height={'100%'}
          data={this.props.data && this.props.data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 1,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="dia" />
          <YAxis />
          <Tooltip />
          <Legend />
          <ReferenceLine y={this.props.total} label="Total Equipamentos" stroke="red" strokeDasharray="3 3" />
          <Line type="monotone" dataKey="total" stroke="#8884d8" activeDot={{ r: 8 }} />

        </LineChart>
      </ResponsiveContainer>
    );
  }
}
